let iconIds = {
	van: 10,
	truck: 20,
	semi: 30,
	trailer: 40,
	tractor: 50,
	ferry: 60,
	plane: 70,
	train: 80,
	crane: 90,
};

/**
 * @description Get cargo carrier icon by id
 *
 * @param {number} type - Cargo carrier type number
 * @returns Icon string
 */
function getIcon(type) {
	switch (type) {
	case (iconIds.van):
		return 'van';
	case (iconIds.semi):
		return 'semi';
	case (iconIds.trailer):
		return 'trailer';
	case (iconIds.tractor):
		return 'tractor';
	case (iconIds.ferry):
		return 'ferry';
	case (iconIds.plane):
		return 'plane';
	case (iconIds.train):
		return 'train';
	case (iconIds.crane):
		return 'crane';
	case (iconIds.truck):
	default:
		return 'truck';
	}
}

export default {
	getIcon,
	iconIds
};